var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-a2f780fe-5a69-4200-8fd6-4e1d720d49e6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-6623de75-b023-43a6-a92e-e5eebf8c34b8 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6623de75-b023-43a6-a92e-e5eebf8c34b8",
    d: "M13.49,17.37c.38,0,1.14-.02,2.21-.46,1.24-.51,3.67-1.43,5.44-2.38,1.24-.67,1.77-1.54,1.77-2.72,0-1.62-1.31-2.95-2.95-2.95h-6.85c-2.34,0-4.25,1.9-4.25,4.25s1.79,4.26,4.63,4.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6623de75-b023-43a6-a92e-e5eebf8c34b8",
    d: "M14.65,20.28c0-1.14.69-2.19,1.75-2.63l2.15-.89c2.19-.89,4.59.7,4.59,3.06,0,1.83-1.48,3.31-3.31,3.31h-2.34c-1.56,0-2.84-1.28-2.84-2.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6623de75-b023-43a6-a92e-e5eebf8c34b8",
    d: "M11.32,17.92h0c-1.35,0-2.46,1.1-2.46,2.46v.32c0,1.33,1.1,2.44,2.46,2.44h0c1.35,0,2.46-1.1,2.46-2.46v-.32c-.02-1.33-1.1-2.44-2.46-2.44Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohere);
export default __webpack_public_path__ + "static/media/Cohere.c8647aa544976578c1935bf0fc138a8e.svg";
export { ForwardRef as ReactComponent };